import { Link } from "react-router-dom"
import { isChurchCenterApp } from "source/Layout"

interface PostDonateSuccessLinksProps {
  orgWebsite?: string
  solicitAddress?: boolean
}

export function PostDonateSuccessLinks({
  solicitAddress = false,
  orgWebsite,
}: PostDonateSuccessLinksProps) {
  if (isChurchCenterApp()) {
    return null
  }
  return solicitAddress ? (
    <>
      <Link to="/me/profile/contact-and-info" className="btn">
        Add a mailing address
      </Link>
      <Link to="/giving/profile/donations" className="btn badge-btn">
        View my giving
      </Link>
    </>
  ) : (
    <>
      <Link to="/giving/profile/donations" className="btn">
        View my giving
      </Link>
      {orgWebsite && (
        <Link to={orgWebsite} className="btn badge-btn">
          Visit our website
        </Link>
      )}
    </>
  )
}
